export class FetchReportTypes {
  public static readonly type = '[ReportTypes] Fetch reportTypes';
}
